import React from 'react';
import InspectionCompletenessSection from './InspectionCompletenessSection';

// The section is shared with the Bridge dashboard — see InspectionCompletenessSection
// for the full implementation and the per-kind (slope/bridge) configuration.
const SlopeInspectionCompletenessSection = () => <InspectionCompletenessSection kind="slope" />;

export default SlopeInspectionCompletenessSection;
